export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-zoom-in-36246694909c7bbbd1601e20d613b6b4.svg";